import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import { constants, mixpanel } from 'common/helpers'

import FullPageScrollSlider from 'components/FullPageScrollSlider/FullPageScrollSlider'

import WelcomeSection from './WelcomeSection/WelcomeSection'
import UpgradeSection from './UpgradeSection/UpgradeSection'
import TimerSection from './TimerSection/TimerSection'


class NewSubscriptionThankYouPage extends Component {

  static propTypes = {
    redirectLink: PropTypes.string,
    isUpgradable: PropTypes.bool,
  }

  onPointerClick = (nextIndex) => {
    mixpanel.track(constants.analyticsEvents.thankYouPointerClick, {
      placement: nextIndex,
    })
  }

  render() {
    const { email, redirectLink, isUpgradable, hasLockedProductsAfterSubscription } = this.props

    return (
      <FullPageScrollSlider onPointerClick={this.onPointerClick}>
        <WelcomeSection email={email} />
        {
          isUpgradable && (
            <UpgradeSection />
          )
        }
        <TimerSection
          redirectLink={redirectLink}
          hasLockedProductsAfterSubscription={hasLockedProductsAfterSubscription}
        />
      </FullPageScrollSlider>
    )
  }
}


export default connect({
  email: 'models.me.email',
})(NewSubscriptionThankYouPage)
